import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./endpointavinfo-widget.html';

        function EndpointAVInfo(params) {

            var self = this;
            self.widgetSignals = params.widgetSignals;
            if (self.widgetSignals)
                self.widgetSignals().dataLoaded.dispatch();

        }

        EndpointAVInfo.prototype.dispose = function () {
        };

        export default { viewModel: EndpointAVInfo, template: templateMarkup };

    
